/**
 * Token saving service
 */
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EHeaderName } from '@app/shared/types/enums/header-name.enum';
import {
  COMPANY_ID,
  EMPLOYEE_ID,
  EVENT_ID,
  SITE_TOKEN,
  SITE_ID,
  ROLE_ID,
} from '@config/global-constants';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';

const DEFAULT_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';

@Injectable()
export class TokenSessionService {
  public token$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public terminalId$: BehaviorSubject<string> = new BehaviorSubject<string>(
    null,
  );

  public constructor(private storage: LocalStorageService) {}

  public saveToken(token, key = DEFAULT_TOKEN_LOCAL_STORAGE_KEY): any {
    return this.storage.setItem(key, token);
  }

  public getToken(key = DEFAULT_TOKEN_LOCAL_STORAGE_KEY): string {
    return this.storage.getItem(key);
  }

  public removeToken(key = DEFAULT_TOKEN_LOCAL_STORAGE_KEY): void {
    this.storage.removeItem(key);
  }

  public removeAll(): void {
    this.removeToken(SITE_ID);
    this.removeToken(SITE_TOKEN);
    this.removeToken(COMPANY_ID);
    this.removeToken(EMPLOYEE_ID);
    this.removeToken(ROLE_ID);
    this.removeToken(EVENT_ID);
  }

  public createTokenInIframeMode(token): object {
    return {
      token,
      user: JSON.parse(atob(token.split('.')[1])),
    };
  }

  public static get employeeId(): string {
    return LocalStorageService.getItem(EMPLOYEE_ID);
  }

  public get employeeId(): string {
    return this.getToken(EMPLOYEE_ID);
  }

  public get roleId(): string {
    return this.getToken(ROLE_ID);
  }

  public get token(): string {
    return this.getToken(SITE_TOKEN);
  }

  public get companyId(): string {
    return this.getToken(COMPANY_ID);
  }

  public get siteId(): string {
    return this.getToken(SITE_ID);
  }

  public get eventId(): string {
    return this.getToken(EVENT_ID);
  }

  public get headers(): HttpHeaders {
    return new HttpHeaders({
      [EHeaderName.Authorization]: `Bearer ${this.token}`,
      [EHeaderName.XCompanyId]: this.companyId,
      [EHeaderName.XSiteIds]: this.siteId,
    });
  }
}
